<template>
  <div>
      <h2>Configure G2 IP Speakers / X10s</h2>
      <div class="col-6">
        <div class="alert alert-warning" role="alert">
          <i class="fa fa-exclamation-triangle fa-fw fa-lg"></i>
          <span class="sr-only">Danger:</span>
          <strong>Danger:</strong> If this is not used with care, there is a potential for unauthorized users to control our devices. To be safe, use a small, closed network and use a small IP range. Make absolutely sure you know what devices are within that IP range. If in doubt, ask Chris Bednar for details.
        </div>
        <div class="form-group">
          <label for="ip_start">IP Start</label>
          <input type="text" class="form-control" id="ip_start" placeholder="10.10.0.1" v-model="ip_start">
        </div>
        <div class="form-group">
          <label for="ip_end">IP End</label>
          <input type="text" class="form-control" id="ip_end" placeholder="10.10.0.255" v-model="ip_end">
        </div>
        <div class="form-group">
          <label for="tftp_server">TFTP Server</label>
          <input type="text" class="form-control" id="tftp_server" placeholder="dev.phoenixbell.online" v-model="tftp_server">
        </div>
        <button :disabled="isWaiting" type="button" class="btn btn-hub-primary" @click="handleSubmit">Set TFTP & Reboot</button>
        <span v-if="isWaiting">
          <i class="fa fa-circle-notch fa-fw fa-spin fa-lg"></i>
          <span class="sr-only">Loading...</span>
        </span>
        <div id="results">
          <div v-for="message in status_messages" :key="message" class="alert alert-info" role="alert">
            {{ message }}
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  components: { },
  data() {
      return {
        ip_start: '',
        ip_end: '',
        tftp_server: '',
        isWaiting: false,
      }
  },
  watch: {
  },
  computed: {
    ...mapGetters({
      status_messages: 'g2_ip_speaker_status_messages',
    }),
  },
  methods: {
    handleSubmit() {
      this.isWaiting = true;
      this.$store.dispatch('G2IPSpeakerAutoReboot', { 'ip_start': this.ip_start, 'ip_end': this.ip_end, 'tftp_server': this.tftp_server }).then(() => {
        this.isWaiting = false;
      });
    },
  },
  created() {
  },
  mounted() {
  }
}
</script>